import { render } from "./help-button.vue?vue&type=template&id=9277cb04"
import script from "./help-button.vue?vue&type=script&lang=js"
export * from "./help-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__